<template>
  <v-card flat class="perso_card" width="100%" @click="goToSub(subItem._id)">
    <v-container fluid>
      <v-row>
        <v-col cols="12" class="pt-0">
          <h2 class="my-4 text-h5">
            {{ subItem.usual_name }} | N°CE : {{ subItem.ce }} | N°CAS :
            {{ subItem.cas }}
          </h2>
          <div class="manyuses overflow-y-auto">
            <ul v-if="subItem.usescase.length" style="list-style: none">
              <li v-for="(use, i) in subItem.usescase" :key="i">
                <v-icon x-small color="primary"> mdi-palette </v-icon>
                <text-highlight :queries="queries">
                  {{ use }}
                  <p class="text-body-1"></p>
                </text-highlight>
              </li>
            </ul>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<style scoped>
.perso_card {
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 0;
}
</style>

<script>
import Vue from "vue";
import TextHighlight from "vue-text-highlight";
import { mapMutations } from "vuex";

Vue.component("text-highlight", TextHighlight);

export default {
  data() {
    return {};
  },
  components: {
    TextHighlight,
  },
  props: {
    subItem: Object,
    queries: String,
    queriesType: {
      type: String,
      default: "",
    },
  },
  computed: {
    useMatch() {
      let regex = new RegExp(`${this.queries}`, "i");
      let array = this.subItem.usescase.filter((use) => {
        if (use.match(regex)) {
          return use;
        }
      });
      return array;
    },
  },
  methods: {
    ...mapMutations(["setLastPage"]),
    goToSub(sub) {
      this.setLastPage({
        name: this.$route.name,
        params: {
          query: this.queries,
          queryType: this.queriesType,
        },
      });
      this.$router.push({
        name: "ShowSubstances",
        params: { id: sub },
      });
    },
  },
};
</script>
